import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LoaderCircle, ShieldAlert } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export default function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.slice(1));
    const sessionId = params.get("session_id");
    if (!sessionId) { setError("Google sign-in did not return a valid session."); return; }
    window.history.replaceState(null, "", window.location.pathname);
    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(response => { setUser(response.data); navigate("/dashboard", { replace: true, state: { user: response.data } }); })
      .catch(error => setError(error.response?.data?.detail || "Google sign-in could not be completed."));
  }, [navigate, setUser]);
  return <main className="flex min-h-screen items-center justify-center bg-[#f2efe7] p-6" data-testid="auth-callback-page"><div className="max-w-md text-center">{error ? <><ShieldAlert className="mx-auto text-[#813f2d]" size={42}/><h1 className="mt-6 font-serif text-4xl" data-testid="auth-callback-error-title">Access could not be completed</h1><p className="mt-4 leading-7 text-[#59675f]" data-testid="auth-callback-error-message">{error}</p><button onClick={() => navigate("/admin/login")} data-testid="auth-callback-return-button" className="mt-7 rounded-full bg-[#244234] px-6 py-3 font-semibold text-white">Return to sign in</button></> : <><LoaderCircle className="mx-auto animate-spin text-[#244234]" size={42}/><p className="mt-5 font-semibold" data-testid="auth-callback-loading">Securing your dashboard session…</p></>}</div></main>;
}